// extracted by mini-css-extract-plugin
module.exports = {"appointmentCardContainer":"AppointmentCard_appointmentCardContainer__Ok7Cc","acDateBig":"AppointmentCard_acDateBig__1KsEP","acContent":"AppointmentCard_acContent__1Fr83"};